export function UploadQuotaExceeded() {
  return (
    <div className="h-16 flex flex-col items-center flex-start text-lg text-palette-red-900 font-semibold">
      You're attempting to import more files than your quota
    </div>
  );
}
